import React, { FC, ReactNode } from "react"

type BodyLayoutProps = {
  children: ReactNode
}

const BodyLayout: FC<BodyLayoutProps> = ({ children }: BodyLayoutProps) => <div className="mw-600">{children}</div>

export { BodyLayout }
